<template>
  <feature-flag-app>
    <accept-tc-inner target="target"/>
  </feature-flag-app>
</template>

<script>
import {FeatureFlagApp} from '@nuskin/ns-feature-flags-vue';

import AcceptTcInner from './ns-accept-tc-inner.vue';

export default {
  name: 'NsLoyaltyAcceptTc',
  components: {
    FeatureFlagApp,
    AcceptTcInner
  },
  props: {
    target: {
      type: String,
      default: '_blank'
    }
  }
}

</script>

<style lang="scss" scoped>

</style>
